import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";

export function useDocumentTypes({ enabled = true, params }) {
  const page = params.page || params.firstResult;
  const size = params.size || params.maxResults;
  const sortOrder = params.sortOrder || "desc";
  const sort = params.sortBy
    ? `${params.sortBy},${sortOrder}`
    : params.sort
      ? `${params.sort},${sortOrder}`
      : "";

  const queryParams = { ...params, page, size, sortOrder, sort };
  return useQuery({
    enabled,
    queryKey: ["document-types", params],
    queryFn: async () =>
      customFetch(
        `/api/documentos/{tenant}/sub-document-types?${new URLSearchParams(queryParams)}`,
      ),
  });
}
